import React from 'react';
import { Box, Spinner } from '@chakra-ui/react';

interface LoadingOverlayProps {
  isLoading: boolean; // Controla si el overlay se muestra o no
}

const BloqueoPantalla: React.FC<LoadingOverlayProps> = ({ isLoading }) => {
  if (!isLoading) {
    return null; // No renderizar nada si no está cargando
  }

  return (
    <Box
      position="fixed"
      top="0"
      left="0"
      width="100vw"
      height="100vh"
      bg="rgba(0, 0, 0, 0.5)"
      display="flex"
      justifyContent="center"
      alignItems="center"
      zIndex="9999"
    >
      <Spinner size="xl" color="white" />
    </Box>
  );
};

export default BloqueoPantalla;
